module.exports = __webpack_public_path__ + "img/circleOrange3.5973c7d7.svg";